import 'react-toastify/dist/ReactToastify.css';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import styled from 'styled-components';

import Header from '@domain/header';

const LayoutContainer = styled.div`
  height: 100vh;
  width: 100vw;
`;

const Container = styled.div`
  display: flex;
  height: calc(100vh - 36px);

  @media only screen and (max-width: 1200px) {
    height: max-content;
  }
`;

const ImageBanner = styled.div`
  width: 35vw;
  height: 100%;
  background: ${({ theme }) => theme.backgroundInput};

  & > div {
    overflow: auto;
  }

  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

interface LeftContainerProps {
  fullWidth?: boolean;
}

const LeftContainer = styled.div<LeftContainerProps>`
  padding: 0 80px;
  overflow-x: hidden;
  overflow-y: auto;
  width: ${(props) => (props.fullWidth ? '100vw' : '65vw')};
  height: calc(100vh - 36px);
  @media only screen and (max-width: 1200px) {
    padding: 0;
    width: 100%;
    height: max-content;
    overflow: hidden;
    padding-bottom: 36px;
  }
`;

const Footer = styled.div`
  background: ${({ theme }) => theme.backgroundInput};
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Link = styled.span`
  color: ${({ theme }) => theme.primary};
  margin: 0 8px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

interface LayoutProps {
  children?: React.ReactNode;
  rightPanel?: React.ReactNode;
}

function Layout({ children, rightPanel }: LayoutProps) {
  return (
    <LayoutContainer>
      <Container>
        <LeftContainer fullWidth={!rightPanel} id={'leftContainer'}>
          <ToastContainer />
          <Header />
          {children}
        </LeftContainer>
        {rightPanel && <ImageBanner>{rightPanel}</ImageBanner>}
      </Container>
      <Footer>
        Developed by <Link>Sectran Ltd</Link> - All rights reserved 2026 ©
      </Footer>
    </LayoutContainer>
  );
}

export default Layout;
